import { Component, OnDestroy, OnInit } from '@angular/core';
import { Alert } from 'app/models/alert';
import { BrowserWindowService } from 'app/services/browser-window.service';
import { AlertStore } from 'app/stores/alert-store';
import { ApplicationStore } from 'app/stores/application-store';
import { ConfirmationService } from 'primeng/primeng';
import { Subscription } from 'rxjs';

@Component({
  selector: 'callsmart-admin-services-panel',
  templateUrl: './admin-services-panel.component.html'
})
export class AdminServicesPanelComponent implements OnInit, OnDestroy {
  public workspaceHeight: number;
  public gridTitle: string = 'Services';
  public drivetimeServiceButtonDisabled: boolean = false;
  public optimiserServiceButtonDisabled: boolean = false;
  private _serviceRestart_subscription: Subscription;

  public constructor(private windowService: BrowserWindowService,
    private confirmationService: ConfirmationService,
    private applicationStore: ApplicationStore,
    private alertStore: AlertStore) {
    //subscribe to the window resize event
    this.windowService.height$.subscribe((value: number) => {
      this.resizeWorkspace(value);
    });
  }

  ngOnInit() { this.subscribeToServiceRestart(); }

  ngOnDestroy(): void {
    if (this._serviceRestart_subscription) {
      this._serviceRestart_subscription.unsubscribe();
    }
  }

  private resizeWorkspace(browserHeight: number) {
    this.workspaceHeight = browserHeight - 200;
  }

  private subscribeToServiceRestart() {
    this._serviceRestart_subscription = this.applicationStore.sysAdminStore.serviceRestart$.subscribe(
      (serviceRestarted: boolean) => {
        if (serviceRestarted != null) {
          this.alertStore.sendAlert(new Alert('Status',
            serviceRestarted ? 'Service startup completed without errors.' : 'Failed to start the service, look in logs'));
        }
      });
  }

  public restartService(serviceName: string) {
    let drivetimeClicked: boolean = serviceName === "Drivetime"
    let optimiserClicked: boolean = serviceName === "Optimiser"

    this.confirmationService.confirm({
      message: `Clicking this button will restart "${serviceName}" service.<br/> All in-progress requests will be stopped and reprocessed.`,
      header: 'Warning',
      accept: () => {
        setTimeout(() => {
          this.drivetimeServiceButtonDisabled = drivetimeClicked ? false : this.drivetimeServiceButtonDisabled;
          this.optimiserServiceButtonDisabled = optimiserClicked ? false : this.optimiserServiceButtonDisabled;
        }, 1000 * 60 * 3);

        this.drivetimeServiceButtonDisabled = drivetimeClicked ? true : this.drivetimeServiceButtonDisabled;
        this.optimiserServiceButtonDisabled = optimiserClicked ? true : this.optimiserServiceButtonDisabled;
        this.applicationStore.sysAdminStore.restartIISRemote(serviceName)
      },
      reject: () => { }
    });
  }
}
